import { render } from "./LeavingSiteNotice.vue?vue&type=template&id=dac3c188"
import script from "./LeavingSiteNotice.vue?vue&type=script&lang=js"
export * from "./LeavingSiteNotice.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\WakeflyUmbraco\\wwwroot\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/LeavingSiteNotice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dac3c188"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dac3c188', __exports__)) {
    api.reload('dac3c188', __exports__)
  }
  
  module.hot.accept("./LeavingSiteNotice.vue?vue&type=template&id=dac3c188", () => {
    api.rerender('dac3c188', render)
  })

}


export default __exports__